<mat-expansion-panel [expanded]="isExpanded" (opened)="(isExpanded)">
  <mat-expansion-panel-header collapsedHeight="24px" expandedHeight="24px">
    <mat-panel-title>
      @if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      {{ title }}
      @if (tooltip) {
        <mat-icon class="tooltip-icon" [matTooltip]="tooltip"
          >info_outline</mat-icon
        >
      }
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-content></ng-content>
</mat-expansion-panel>
